module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAWCAYAAADTlvzyAAABRklEQVRIiZ2WzY3CMBCFH4g72wHpADpg0Z4RlEAHUAIlwI0j2wnbwdIB6QA6QBPZaJjMj81IkZz4s9+8sRNnsPw5wYgZgHXqatJF8QVgmtoLAJfULuJHlhqADYCt009xZhMX8UOn8zsYDOYOyWHIW4K8DF4cGD8v4E2HJe6uAP4redPh2njO48DaJYId/6nDNm2Y0gQfmdcEafEnwQRcrCngX9XQBEuy5eWs4j8RpMF3dr8J+DPnpWATvA7SXcRD8D3BWncRfwRw8wR3zmDpDkE5id/Lh1ww2p3SXVROyfcEvWxbxV1tNaoE90q23vrtNHdckAaPjcF/4kXPvFX+q8L3BCN3MjzeK3UnSIu/MvqP4sxDwP8qfE/QyqitdPeI3GVBdXHTxFpfLf8W9E8jXdCXgQ7WfLjKoO1OZc2TE0+XW8ouADwBwJ5KXDaI5Y4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 1